/* src/app/private/components/tool-bar/tool-bar.component.scss */
.prominent-add-btn {
  font-size: 1.15rem !important;
  font-weight: 700 !important;
  background: var(--primary-color, #2563eb) !important;
  color: #fff !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px 0 rgba(37, 99, 235, 0.15);
  padding: 0.75rem 2.25rem !important;
  border: none !important;
  margin-left: 1.5rem !important;
  letter-spacing: 0.5px;
  transition: background 0.2s;
}
.prominent-add-btn:hover,
.prominent-add-btn:focus {
  background: #174ea6 !important;
  color: #fff !important;
}
.tool-bar {
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2509803922);
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  align-items: center;
}
.tool-bar-left-heading {
  display: flex;
  gap: 8px;
  font-size: 21px;
  align-items: center;
  color: var(--primary-color);
  font-weight: 500;
}
.date-picker-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}
.date-picker-input-box {
  display: flex;
  align-items: center;
  border-radius: 30px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922) inset;
  padding: 0px 16px;
  padding-right: 6px;
  padding-top: 2px;
}
.date-picker-outer-box {
  border-radius: 30px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922);
  border: 1px solid #FFFFFF;
}
.refresh-box {
  background-color: var(--primary-color);
  padding: 3px 15px;
  border-radius: 30px;
  color: #fff;
  cursor: pointer;
}
.search-outer-box {
  border-radius: 30px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922);
  border: 1px solid #FFFFFF;
}
.search-input-box {
  display: flex;
  align-items: center;
  border-radius: 30px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922) inset;
  padding: 0px 16px;
  padding-right: 6px;
  padding-top: 2px;
}
.search-outer-box .p-select {
  border: none !important;
  box-shadow: none !important;
  width: 120px;
  margin-left: -14px;
  margin: 5px;
  margin-left: -9px;
  background: var(--primary-color);
  color: #fff;
}
.search-outer-box .p-select-dropdown {
  color: #fff !important;
  padding: 0px;
  margin: 0px;
  width: 11px;
  font-size: 10px;
  margin-right: 5px;
}
.p-select-label {
  color: #fff !important;
}
.p-select-dropdown {
  color: #fff !important;
  padding: 0px;
  margin: 0px;
  width: 11px;
  font-size: 10px;
  margin-right: 5px;
}
.searchby-select {
  border: none;
  font-size: 12px;
  padding: 0px;
  background-color: var(--primary-color);
  padding: 0px 9px;
  border-radius: 31px;
  margin-left: -8px;
  color: #fff;
  height: 25px;
}
.action-items span {
  position: relative;
}
.action-items span:not(:last-child)::after {
  content: "";
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 20px;
  background: rgba(130, 123, 123, 0.43);
}
.p-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}
/*# sourceMappingURL=tool-bar.component.css.map */
